// Render shape SVG
export const renderShape = (shape, color) => {
  const shapeMap = {
    circle: <circle cx="50" cy="50" r="35" fill={color} />,
    square: <rect x="15" y="15" width="70" height="70" fill={color} />,
    triangle: <polygon points="50,15 85,85 15,85" fill={color} />,
    diamond: <polygon points="50,15 85,50 50,85 15,50" fill={color} />,
    pentagon: <polygon points="50,15 90,40 75,85 25,85 10,40" fill={color} />,
    hexagon: <polygon points="50,10 85,30 85,70 50,90 15,70 15,30" fill={color} />,
    star: <polygon points="50,15 61,45 92,45 68,65 78,95 50,75 22,95 32,65 8,45 39,45" fill={color} />,
    cross: <path d="M 35,15 L 65,15 L 65,35 L 85,35 L 85,65 L 65,65 L 65,85 L 35,85 L 35,65 L 15,65 L 15,35 L 35,35 Z" fill={color} />
  };
  return shapeMap[shape] || shapeMap.circle;
};

